import React from "react";
import s from './supportBlock.module.scss';
import locales from '../../../content.json';

export const SupportBlock = () => {

  return(
    <div className={s.supportBlock}>
      <h3>
        {locales[window.userLang].payment_text_17}
      </h3>
      <p>
        {locales[window.userLang].payment_text_18}
      </p>
      <a href="mailto:welove@everydoggy.com">
        welove@everydoggy.com
      </a>
    </div>
  )
}